import { memo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const RedirectOldUrlRouter = () => {
  const location = useLocation();

  const pathName = location.pathname.replace('/v3', '');
  return <Navigate to={`${pathName}${location.search}`} replace={true} />;
};

export default memo(RedirectOldUrlRouter);
